document.addEventListener("DOMContentLoaded", () => {
    $(document).on(`click`, `.mobile-multstores [toggle-mobile-stores]`, function(e){
      e.preventDefault();
      e.stopPropagation();
      var nextElement = $(this).parent().next(`ul`);
      if(nextElement.is(":hidden")){
        nextElement.slideToggle();
        $(this).addClass(`active`).attr("aria-expanded","true");
      } else {
        nextElement.slideToggle();
        $(this).removeClass(`active`).attr("aria-expanded","false");
      }
    });
  });